import { isDefined } from "@clipboard-health/util-ts";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";
import { useMemo } from "react";

import { DEFAULT_REFERRAL_POST_BOOKING_CTA_CONFIG } from "./constants";

interface UseReferralPostBookingCtaParams {
  workplaceType: string | undefined;
}

interface UseReferralPostBookingCtaResult {
  isEligible: boolean;
}

export function useReferralPostBookingCta(
  params: UseReferralPostBookingCtaParams
): UseReferralPostBookingCtaResult {
  const { workplaceType } = params;

  const config = useCbhFlag(CbhFeatureFlag.REFERRAL_POST_BOOKING_CTA, {
    defaultValue: DEFAULT_REFERRAL_POST_BOOKING_CTA_CONFIG,
  });

  const isEligible = useMemo(() => {
    if (!config.enabled) {
      return false;
    }

    const { workplaceTypes } = config;

    if (!isDefined(workplaceTypes)) {
      return true;
    }

    if (workplaceTypes.length === 0) {
      return false;
    }

    return isDefined(workplaceType) && workplaceTypes.includes(workplaceType);
  }, [config, workplaceType]);

  return { isEligible };
}
